import React from 'react';

import { styled } from 'styled-components';

import theme from 'styles/theme';

import { ArticleDate } from 'components/ArticleDate';
import CtaCard from 'components/CtaCard/CtaCard';
import CtaCardImage, { SrcSet } from 'components/CtaCard/CtaCardImage';
import InnerHtml from 'components/InnerHtml/InnerHtml';

import { BlogPostI } from 'interfaces/content-stack/blogPost';
import { FetchPriority } from 'interfaces/html';

import { autoOptimizeImage, buildBreadcrumbUrls } from 'utils/functions';

const ArticleTitle = styled.div`
  font-family: ${(props) => props.theme.fonts.default};
  font-size: 1.25rem;
  font-weight: 800;
  line-height: 1.4;
  margin-bottom: 1rem;

  @media (max-width: ${(props) => props.theme.breakpoints.lg}) {
    font-size: 1.15rem;
  }
`;

const ArticlePreview = styled.div`
  font-weight: 500;
  font-family: ${(props) => props.theme.fonts.default};
`;

const FEATURED_ARTICLE_IMAGE_WIDTH_DESKTOP = 900;
const FEATURED_ARTICLE_IMAGE_WIDTH_MOBILE = 365;

const FeaturedArticle = ({ article }: { article: BlogPostI }) => {
  const { breadcrumb, metadata, postDate, title, url } = article;

  const thumbnailUrl = metadata?.thumbnailImage?.url;
  const imageMobile = autoOptimizeImage(thumbnailUrl, true, `${FEATURED_ARTICLE_IMAGE_WIDTH_MOBILE}`);

  const srcSets: SrcSet[] = [{ srcSet: imageMobile, max: theme.breakpoints.values.xs }];

  return (
    <CtaCard
      link={buildBreadcrumbUrls(breadcrumb, url)}
      imgComponent={
        <CtaCardImage
          imageUrl={thumbnailUrl}
          imageWidth={FEATURED_ARTICLE_IMAGE_WIDTH_DESKTOP}
          imageAltText={metadata.thumbnailAltText}
          srcSets={srcSets}
          fetchPriority={FetchPriority.HIGH}
        />
      }
      fullHeight
    >
      <ArticleDate date={postDate} />
      <ArticleTitle>{title}</ArticleTitle>
      <ArticlePreview>
        <InnerHtml richText={metadata.excerpt} />
      </ArticlePreview>
    </CtaCard>
  );
};

export default FeaturedArticle;
